import { ActionCard } from "../../../Models/ActionCard";
import { OrderSummary } from "../../../Models/OrderSummary";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export class ActionCardAPIHandler {

  public static shared = new ActionCardAPIHandler()

  apiHandler = BaseAPICallsHandler.shared
  serverConfig = ServerConfig.shared
  networkUtils = NetworkUtils.shared

  // dependency injection here
  constructor();
  constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
  public constructor(...params: any[]) {
    if (params.length >= 3) {
      this.apiHandler = params[0];
      this.serverConfig = params[1];
      this.networkUtils = params[2];
    }
  };

  public async createActionCard(actionCardData: any) {
    let createActionCardUrl = this.serverConfig.ActionCardAPIs.saveActionCardAPI;
    let authHeaders = this.networkUtils.addAuthHeaders({
      'Content-Type': 'multipart/form-data'
    });

    try {
      let actionCardResponse = await this.apiHandler.makePostRequest(authHeaders, createActionCardUrl, actionCardData);
      let cardData = actionCardResponse.data
      let actionCard = new ActionCard(cardData);
      return Promise.resolve(actionCard);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getActionCardProposalBreakup(actionCardData: any): Promise<OrderSummary>  {
    let url = this.serverConfig.ActionCardAPIs.getActionCardSummaryBreakdownAPI;
    let authHeaders = this.networkUtils.addAuthHeaders({
      'Content-Type': 'multipart/form-data'
    });

    try {
      let response = await this.apiHandler.makePostRequest(authHeaders, url, actionCardData);
      let data = response.data
      let summary = new OrderSummary(data);
      return Promise.resolve(summary);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getActionCardById(cardID: string): Promise<ActionCard> {
    let url = this.serverConfig.ActionCardAPIs.actionCardAPI + cardID;
    const authHeaders = this.networkUtils.addAuthHeaders({});
    try {
      let actionCardResponse = await this.apiHandler.makeGetRequest(authHeaders, url);
      let cardData = actionCardResponse.data
      let actionCard = new ActionCard(cardData);
      return Promise.resolve(actionCard);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getActionCardsByChannelId(channelId: string): Promise<ActionCard[]> {
    let url = this.serverConfig.ActionCardAPIs.actionCardsByChanneAPI + channelId;
    const authHeaders = this.networkUtils.addAuthHeaders({});
    try {
      let actionCardResponse = await this.apiHandler.makeGetRequest(authHeaders, url);
      let cardList = actionCardResponse.data
      return Promise.resolve(cardList);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async updateActionCard(cardId: string, status: string):  Promise<ActionCard> {
    let url = this.serverConfig.ActionCardAPIs.actionCardAPI + cardId;
    const authHeaders = this.networkUtils.addAuthHeaders({});
    try {
      let actionCardResponse = await this.apiHandler.makePutRequest(authHeaders, url, {status});
      let card = new ActionCard(actionCardResponse.data);
      return Promise.resolve(card);
    } catch (err) {
      return Promise.reject(err);
    }
  }


}